import React, { useCallback } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Dropdown from "rsuite/esm/Dropdown";
import IconButton from "rsuite/esm/IconButton";
import Whisper from "rsuite/esm/Whisper";
import Popover from "rsuite/esm/Popover";
import { BsThreeDotsVertical } from "react-icons/bs";

const DealsActionColumn = ({ value, setActionColData }) => {
    const history = useHistory();
    console.log("DealsActionColumn value:", value); // Debugging log

    const isGeneralUser = Number(localStorage.getItem("is_general_user"));
    const storePermission = Number(localStorage.getItem("store_permission"));

    const hasAllowedProductType = (
        productList,
        idsToCheck,
        allowedTypes = ["paying", "free_trial"]
    ) => {
        // validate inputs
        if (!Array.isArray(productList) || !Array.isArray(idsToCheck)) {
            return false;
        }

        if (!idsToCheck.length || !productList.length) {
            return false;
        }

        // ensure ids are strings
        const validIds = idsToCheck.filter(id => typeof id === "string");

        if (!validIds.length) {
            return false;
        }

        const matchedTypes = productList
            .filter(
                item =>
                    typeof item === "string" &&
                    validIds.some(id => item.startsWith(`${id}:`))
            )
            .map(item => item.split(":")[1]);

        return allowedTypes.some(type =>
            matchedTypes.includes(type)
        );
    };


  

    /* ------------------ Actions ------------------ */

    const handleMarkAsPaid = useCallback((value) => {
        // const deals = value && value.deals ? value.deals : {};
        // const user = deals.user || {};

        const markAsPaidModalData = {
            product_key: value.product_key || "",
            customer_user_uuid: value.customer_user_uuid || "",
            milestone_uuid: value.milestone_uuid || "",
            deal_uuid: value.deal_uuid || "",
            mautic_id: value.mautic_id || "",
        };

        setActionColData((prevState) => ({
            ...prevState,
            markAsPaidModalData,
            openModal: "markAsPaid"
        }));
    }, []);

    const handleRaiseInvoice = useCallback((value) => {

        const raiseCustomInvoiceModalData = {
            product_key: value.product || "",
            customer_id: value.customer_id || "",
            product_account_type: value.product_account_type || "",
            customer_user_uuid: value.customer_user_uuid || "",
            customer_tattle_uuid: value.customer_tattle_uuid || "",
            enterprise_api_gateway_url: value.enterprise_api_gateway_url || "",
            server_id: value.server_id || 0,
            milestone_uuid: value.milestone_uuid || "",
            isDeal: true,
            milestone_amount: value.milestone_amount || 0,
            customer_id: value.customer_id || "",
            mautic_id: value.mautic_id || "",
        };

        setActionColData((prevState) => ({
            ...prevState,
            raiseCustomInvoiceModalData,
            openModal: "raiseCustomInvoice"
        }));
    }, []);

    /* ------------------ Render Dropdown Items ------------------ */

    const status = value && value.milestone_status;

    const canRaiseInvoice =
        storePermission === 1 &&
        status === "Draft" &&
        hasAllowedProductType(value.product_account_type, value.product, ["paying", "free_trial"]);


    const canMarkAsPaid =
        storePermission === 1 && status !== "Paid" && status !== "Lost";

    /* ------------------ Guard ------------------ */

    // if (isGeneralUser === 1) return null;

    /* ------------------ UI ------------------ */

    return (
        <div className="deals-action-column">
            <Whisper
                placement="bottomEnd"
                trigger="click"
                container={() => document.body}
                speaker={
                    <Popover full>
                        <Dropdown.Menu>
                            {canRaiseInvoice && !isGeneralUser && (
                                <Dropdown.Item onClick={() => handleRaiseInvoice(value)}>
                                    Raise Invoice
                                </Dropdown.Item>
                            )}

                            {canMarkAsPaid  && !isGeneralUser && (
                                <Dropdown.Item onClick={() => handleMarkAsPaid(value)}>
                                    Mark as Paid
                                </Dropdown.Item>
                            )}

                            {/* <Dropdown.Item onClick={() => handleEditDeal(value.deal_uuid)}>
                Edit
              </Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Popover>
                }
            >
                <IconButton icon={<BsThreeDotsVertical />} appearance="subtle" size="sm" />
            </Whisper>
        </div>
    );
};

export default DealsActionColumn;


// WEBPACK FOOTER //
// ./src/components/crm/deals/components/DealsActionColumn.js